import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Pierre",
    role: "Éducateur canin & Fondateur — K9 Transform",
    location: "Tarn (81)",
    quote:
      "J'ai fais faire mon site par Marius pour ma future activité professionnelle. Il s'est montré très investi, motivé et le résultat final a clairement dépassé mes attentes. J'avais pourtant donné en exemple, un site complexe à reproduire et je n'ai pas été déçu du travail de Marius. Je recommande les yeux fermés.",
    image:
      "https://images.unsplash.com/photo-1503256207526-0d5d80fa2f47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxkb2clMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODE2MTQwNDF8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Photo de Pierre, éducateur canin et fondateur de K9 Transform, client WebUP",
  },
  {
    name: "Isabelle Geyer",
    role: "Artisane boulangère — La Petite Gourmandise",
    location: "Tarn (81)",
    quote:
      "Belle page sur l'activité professionnelle de La Petite Gourmandise, bien réalisée avec la bonne image de notre savoir-faire. Une recherche et une description très élégantes de notre travail. Je félicite, recommande vivement et remercie.",
    image:
      "https://images.pexels.com/photos/10612722/pexels-photo-10612722.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Photo d'Isabelle Geyer, artisane boulangère à La Petite Gourmandise, cliente WebUP dans le Tarn",
  },
];

export const SocialProof = () => (
  <section id="temoignages" data-testid="social-proof-section" className="py-24 md:py-32 bg-paper-soft border-y border-ink/5">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="flex items-end justify-between gap-8 flex-wrap mb-16">
        <div>
          <p className="font-mono-label text-ink/60"><span className="rule" />Ils nous font confiance</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl text-ink tracking-tight max-w-3xl">
            La parole à nos clients, <em className="font-light italic">artisans et entrepreneurs du Tarn</em>.
          </h2>
        </div>
        <div className="text-sm text-ink/60 max-w-xs">
          Chaque projet est traité avec la même exigence.
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
        {testimonials.map((t, i) => (
          <figure
            key={t.name}
            data-testid={`testimonial-card-${i}`}
            className="group bg-white border border-ink/10 p-8 md:p-10 flex flex-col gap-6 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_80px_-40px_rgba(26,42,69,0.35)]"
          >
            <Quote className="text-ink/30" size={28} />
            <blockquote className="text-ink text-[17px] leading-relaxed">
              « {t.quote} »
            </blockquote>
            <div className="mt-auto flex items-center gap-4 pt-6 border-t border-ink/10">
              <div className="h-14 w-14 overflow-hidden rounded-full ring-1 ring-ink/10 shrink-0">
                <img
                  src={t.image}
                  alt={t.imageAlt || t.name}
                  title={t.name}
                  width="112"
                  height="112"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover"
                />
              </div>
              <figcaption>
                <p className="font-medium text-ink">{t.name}</p>
                <p className="text-sm text-ink/60">{t.role}</p>
                <p className="text-xs text-ink/45 mt-0.5">{t.location}</p>
              </figcaption>
            </div>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
